import { Helmet } from 'react-helmet';

const SEO = ({ 
    title = "Wilson Tamuka Attorneys | Zimbabwean Law Firm",
    description = "Wilson Tamuka Attorneys is a full legal service firm, Locally and Internationally offering expert legal services in commercial law, property law, litigation, and more.",
    keywords = "Zimbabwe lawyers, Harare attorneys, commercial law Zimbabwe, property law, litigation",
    canonical = "https://wtafirm.co.zw",
    ogImage = "https://wtafirm.co.zw/og-image.jpg",
    type = "website"
}) => {
    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <link rel="canonical" href={canonical} />
            
            {/* Open Graph */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content={type} />
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={ogImage} />
            
            {/* Twitter */}
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />
        </Helmet>
    );
};

export default SEO;
